import script from "./AccordionImageGallery.vue?vue&type=script&setup=true&lang=ts"
export * from "./AccordionImageGallery.vue?vue&type=script&setup=true&lang=ts"

import "./AccordionImageGallery.vue?vue&type=style&index=0&id=7758d52a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7758d52a"]])

export default __exports__